import {
	AfterContentInit,
	ApplicationRef,
	Component,
	ContentChildren,
	QueryList
} from "@angular/core";
import {TabDirective} from "./tab.directive";

@Component({
	selector: "tabs",
	template: `
		<section class="segmentedtabs">
			<div *ngFor="let tab of tabs" class="segmentedtab" [class.active]="tab.active" (click)="setActiveTab(tab.id)">
				<h2 class="segmentedtab_title">{{tab.tabTitle}}</h2>
				<p class="segmentedtab_subtitle">{{tab.tabSubtitle}}</p>
			</div>
		</section>

		<ng-content></ng-content>
	`,
})
export class TabsComponent implements AfterContentInit {
	activeTab: string;

	@ContentChildren(TabDirective) tabs: QueryList<TabDirective>;

	constructor(private readonly applicationRef: ApplicationRef) {
	}

	ngAfterContentInit() {
		if (this.activeTab == null && this.tabs.length > 0)
			this.activeTab = this.tabs.first.id;

		// The setImmediate() avoids an ExpressionChangedAfterItHasBeenCheckedError in some cases
		setImmediate(() => {
			this.updateChildren();
			this.applicationRef.tick();
		});

		this.tabs.changes
			.subscribe(() => this.updateChildren());
	}

	setActiveTab(tabID: string) {
		this.activeTab = tabID;
		this.updateChildren();
	}

	updateChildren() {
		this.tabs.forEach(t => t.active = (t.id === this.activeTab));
	}
}
